import axios from 'axios';
import dayjs from 'dayjs';

import { logger } from 'Services/logger/logger';

import { downloadCsv } from './useDownloadCsvPolling/useDownloadCsvPolling.helpers';

type DownloadCsvStaticMethodProps = {
	filenameTitle: string;
	setIsStaticFileDownloading: (isStaticFileDownloading: boolean) => void;
	shouldAppendBulkBiddingColumn: boolean;
	staticUrl: string;
};

export const formatDownloadCsvFilename = (filenameTitle: string): string => {
	return `${filenameTitle} ${dayjs(new Date()).format('DD-MM-YYYY HH_mm')}`;
};

export const downloadCsvPollingMethod = async (startPolling: () => Promise<void>): Promise<void> => {
	try {
		await startPolling();
	} catch (e) {
		const error = e instanceof Error ? e : new Error('There was an error while starting polling');
		logger.warn({ error, message: error.message, scope: 'downloadCsv' });
	}
};

export const downloadStaticCsv = async ({
	filenameTitle,
	setIsStaticFileDownloading,
	shouldAppendBulkBiddingColumn,
	staticUrl,
}: DownloadCsvStaticMethodProps): Promise<void> => {
	try {
		setIsStaticFileDownloading(true);

		const response = await axios.get(staticUrl);

		if (response.status) {
			setIsStaticFileDownloading(false);
		}

		await downloadCsv({
			content: response.data,
			filename: formatDownloadCsvFilename(filenameTitle),
			shouldAppendBulkBiddingColumn,
		});
	} catch (e) {
		setIsStaticFileDownloading(false);
		const error = e instanceof Error ? e : new Error('There was an error while downloading static CSV');
		logger.warn({ error, message: error.message, scope: 'downloadCSV' });
	}
};
